export default "assets/images/logo_large-51dc435a.png";